var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ek-table',{attrs:{"columns":_vm.columns,"items":_vm.universities},on:{"delete-selected":_vm.deleteUni,"details":_vm.detailsAppPanel},scopedSlots:_vm._u([{key:"items.dateCreated",fn:function(ref){
var value = ref.value;
return [_c('span',[_vm._v(" "+_vm._s(new Date(value).toLocaleDateString()))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }